export const sweatpalsGTagManagerId = process.env['NEXT_PUBLIC_SWEATPALS_GTM_ID'];
